import { z } from 'zod';
const CNPJ_REGEX = /^([A-Z\d]){12}(\d){2}$/;
const CNPJ_LENGTH = 14;
const CNPJ_LENGTH_WITHOUT_VD = 12;
const BASE_CNPJ_VALUE = '0'.charCodeAt(0);
const VD_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const calculateVD = (cnpj) => {
    let sumVD1 = 0;
    let sumVD2 = 0;
    for (let i = 0; i < CNPJ_LENGTH_WITHOUT_VD; i++) {
        const currentCharCode = cnpj.charCodeAt(i) - BASE_CNPJ_VALUE;
        sumVD1 += currentCharCode * (VD_WEIGHTS[i + 1] ?? 0);
        sumVD2 += currentCharCode * (VD_WEIGHTS[i] ?? 0);
    }
    const dv1 = sumVD1 % 11 < 2 ? 0 : 11 - (sumVD1 % 11);
    sumVD2 += dv1 * (VD_WEIGHTS[CNPJ_LENGTH_WITHOUT_VD] ?? 0);
    const dv2 = sumVD2 % 11 < 2 ? 0 : 11 - (sumVD2 % 11);
    return `${dv1}${dv2}`;
};
const isCNPJValid = (cnpj) => {
    const informedVD = cnpj.substring(CNPJ_LENGTH_WITHOUT_VD);
    const calculatedVD = calculateVD(cnpj.substring(0, CNPJ_LENGTH_WITHOUT_VD));
    return informedVD === calculatedVD;
};
export const CnpjVO = z
    .string()
    .length(CNPJ_LENGTH)
    .regex(CNPJ_REGEX)
    .refine(isCNPJValid, 'CNPJ inválido');
//# sourceMappingURL=cnpj.js.map